<ng-container *ngIf="!isOptionLoading;else Loading">
  <app-nav-header [CompanyID]="CompanyID" [UserID]="UserID" [Liff_ID]="Liff_ID" [title]="'同意書'"></app-nav-header>  
      <ng-container *ngIf="!isOptionLoading;else Optionloading">
        <p-accordion [activeIndex]="activeIndex">
            <p-accordionTab *ngFor="let consentForm of editModel" header="{{consentForm.ConsentFormName}}">
                <p-scrollPanel #consentFormScrollPanel [style]="{ width: '100%', height: '300px','padding':'10px' }">
                <p [style]="{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }">{{ consentForm.consentFormContent }}</p>
                <div class="flex gap-3">
                  <img *ngIf="!!consentForm.SignPath;" src="{{ baseUrl }}/{{ consentForm.SignPath }}" width="100px">
                  <button *ngIf="!!consentForm.SignPath == false;" pButton type="button" label="簽名" class="p-button-info" (click)="Sign(consentForm)"></button>
                </div>
                </p-scrollPanel>
            </p-accordionTab>
        </p-accordion>
        <p-sidebar [(visible)]="showDialog" [fullScreen]="true">
            <ng-template pTemplate="header">
                <span class="font-semibold text-xl">
                    簽名板
                </span>
            </ng-template>
            <div class="signature-container p-3">
            <div class="sign-box">
                <ngx-signature-pad #sig [options]="options" class="sign-canvas"
                (beginSign)="onBegin()"
                (endSign)="onEnd()">
                </ngx-signature-pad>
            </div>
            <button pButton label="清除" class="p-button-secondary w-full" (click)="clear()"></button>
            <button pButton label="儲存" class="p-button-success w-full" [loading]="loading" (click)="save()"></button>
            </div>
        </p-sidebar>    
      </ng-container>
      <ng-template #Optionloading>
        <form class="page__content pageForm" style="width: 350px;text-align: center;">
          <div class="row">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </div>
        </form>
      </ng-template>
  </ng-container>
<ng-template #Loading>
<p-progressSpinner ariaLabel="loading" />
</ng-template>